import * as React from "react";
import styled from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import useProductName from "brand-customization/useProductName";
import { Link, IfPermitted, Spinner } from "components/common";
import { Alert, Col, Row } from "components/bootstrap";
import AppConfig from "util/AppConfig";
import { LICENSE_TYPES, LICENSE_SUBJECTS } from "license/constants";
import LicensesRoutes from "license/Routes";
import useLicenseValidityForSubject from "./hooks/useLicenseValidityForSubject";
const isCloud = AppConfig.isCloud();
const StyledP = styled.p`
  white-space: break-spaces;
`;
export const Warning = ({
  title = null,
  text = null,
  bsStyle = "info",
  licenseSubject = LICENSE_SUBJECTS.enterprise,
  featureName
}) => {
  const { t } = useTranslation("enterprise_license");
  const productName = useProductName();
  const licenseType = `${productName} ${LICENSE_TYPES[licenseSubject]}`;
  return /* @__PURE__ */ React.createElement(Alert, { bsStyle, title: title != null ? title : t("license.check.license_required_title", { licenseType }) }, /* @__PURE__ */ React.createElement(StyledP, null, text != null ? text : featureName ? t("license.check.license_required_text", { licenseType, featureName }) : t("license.check.license_required_text_generic", { licenseType })), isCloud ? /* @__PURE__ */ React.createElement(React.Fragment, null, t("license.check.contact_account_manager")) : /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "licenses:create" }, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "license.check.licenses_page_details",
      components: { licensesLink: /* @__PURE__ */ React.createElement(Link, { to: LicensesRoutes.LIST }) }
    }
  ))));
};
export const InvalidLicenseWarning = ({
  licenseSubject = LICENSE_SUBJECTS.enterprise,
  featureName,
  displayWarningContainer,
  title = null,
  text = null,
  bsStyle = "info"
}) => {
  if (displayWarningContainer) {
    return /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(
      Warning,
      {
        licenseSubject,
        featureName,
        title,
        text,
        bsStyle
      }
    )));
  }
  return /* @__PURE__ */ React.createElement(Warning, { licenseSubject, featureName, title, text, bsStyle });
};
const LicenseCheck = ({
  children = void 0,
  featureName = null,
  licenseSubject = LICENSE_SUBJECTS.enterprise,
  displayLicenseWarning = true,
  displayWarningContainer = false,
  hideChildren = false,
  title = null,
  text = null,
  bsStyle = "info"
}) => {
  const {
    data: { valid },
    isInitialLoading: isLoading
  } = useLicenseValidityForSubject(licenseSubject);
  const resultChildren = typeof children === "function" ? children({ licenseIsValid: valid }) : children;
  if (isLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, !valid && displayLicenseWarning && /* @__PURE__ */ React.createElement(
    InvalidLicenseWarning,
    {
      licenseSubject,
      featureName,
      displayWarningContainer,
      title,
      text,
      bsStyle
    }
  ), valid && resultChildren, !valid && !hideChildren && resultChildren);
};
export default LicenseCheck;
